module.exports = __webpack_public_path__ + "static/mabawonku-12335e86c6f802215d916b872f669af5.jpg";